// extracted by mini-css-extract-plugin
export default {"content":"style_content__aDQuH","form":"style_form__ygCY4","info":"style_info__y+sZo"};